"use client";

import { useRef } from "react";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import NavSearchResults from "@/components/nav/NavSearchResults";

/**
 * Search over a small screen, where there is no rail to open a pane beside:
 * the same input and results in a dialog. `search` is the side nav's
 * `useNavSearch` instance.
 */
export default function NavSearchDialog({ search, apple }) {
  const inputRef = useRef(null);

  return (
    <Dialog open={search.open} onOpenChange={search.setOpen}>
      <DialogContent
        hideCloseButton
        onOpenAutoFocus={(event) => {
          // Radix would focus and select the input itself; the hook decides
          // whether a seeded keystroke keeps the caret after it.
          event.preventDefault();
          search.focusInput(inputRef.current);
        }}
        className="top-[12vh] max-h-[78vh] max-w-2xl translate-y-0 overflow-hidden rounded-2xl border-gray-200 bg-white p-0 !text-gray-900 shadow-[0_24px_70px_-20px_rgba(17,24,39,0.28)] sm:rounded-2xl"
      >
        <DialogTitle className="sr-only">Search</DialogTitle>
        <NavSearchResults
          search={search}
          inputRef={inputRef}
          apple={apple}
          className="rounded-2xl bg-white"
          inputClassName="h-12"
          listClassName="max-h-[58vh] min-h-[220px]"
        />
      </DialogContent>
    </Dialog>
  );
}
